
import { Component, Prop, Vue } from 'vue-property-decorator';
import { OrderStatus } from '@/interfaces';
import OrdersService from '@/services/orders';

@Component
export default class AdminStatusChanger extends Vue {
  @Prop({ required: true }) readonly orderId!: number;
  @Prop({ required: true }) readonly currentStatus!: OrderStatus;

  selectedStatus: OrderStatus | null = null;
  isLoading = false;
  message = '';
  messageType: 'success' | 'error' | 'info' = 'info';

  get availableStatuses() {
    return [
      { label: 'New', value: OrderStatus.new },
      { label: 'Processing', value: OrderStatus.processing },
      { label: 'Ready for Pickup', value: OrderStatus.ready_for_pickup },
      { label: 'Finished', value: OrderStatus.finished },
      { label: 'Rejected', value: OrderStatus.rejected },
      { label: 'Finished Auto', value: OrderStatus.finished_auto },
    ];
  }

  mounted() {
    this.selectedStatus = this.currentStatus;
  }

  async updateStatus() {
    if (!this.selectedStatus || this.selectedStatus === this.currentStatus) {
      return;
    }

    // Confirm the status change
    const confirmed = confirm(
      `Are you sure you want to change the order status from "${this.currentStatus}" to "${this.selectedStatus}"?`
    );

    if (!confirmed) {
      this.selectedStatus = this.currentStatus;
      return;
    }

    this.isLoading = true;
    this.message = '';

    try {
      await OrdersService.updateStatusByAdmin(this.orderId, this.selectedStatus);

      this.message = `Status successfully updated to ${this.selectedStatus}`;
      this.messageType = 'success';

      // Emit event to parent to refresh order data
      this.$emit('statusUpdated', {
        orderId: this.orderId,
        newStatus: this.selectedStatus,
      });

      // Clear message after 3 seconds
      setTimeout(() => {
        this.message = '';
      }, 3000);
    } catch (error: any) {
      console.error('Error updating status:', error);
      this.message = error.response?.data?.message || 'Failed to update status';
      this.messageType = 'error';

      // Reset to current status on error
      this.selectedStatus = this.currentStatus;
    } finally {
      this.isLoading = false;
    }
  }
}
